import { Misc } from "../";
import { TimeSpan } from "./TimeSpan";
var DateUtils = /** @class */ (function () {
    function DateUtils() {
    }
    DateUtils.format = function (dateOrDateProperty, formatString, utc) {
        if (utc === void 0) { utc = false; }
        var date = dateOrDateProperty;
        var dateProperty = dateOrDateProperty;
        if (dateProperty === null || dateProperty === void 0 ? void 0 : dateProperty.propertyInfo) {
            date = dateProperty.value;
            formatString = dateProperty.propertyInfo.timeZoneSerialisation === Misc.TimeZoneFormat.None ? DateUtils.defaultFormatString : DateUtils.defaultFormatStringWithTime;
        }
        if (!date)
            return "";
        // Passing date through Date applies Date.parse, if necessary
        if (isNaN(date))
            throw SyntaxError("invalid date");
        if (!formatString)
            formatString = DateUtils.defaultFormatString;
        formatString = formatString.replace(/ /g, '\xA0'); //replace spaces with non-breaking spaces.
        // Allow setting the utc argument via the mask
        if (formatString.slice(0, 4) == "UTC:") {
            formatString = formatString.slice(4);
            utc = true;
        }
        var _ = utc ? "getUTC" : "get", d = date[_ + "Date"](), D = date[_ + "Day"](), M = date[_ + "Month"](), y = date[_ + "FullYear"](), H = date[_ + "Hours"](), m = date[_ + "Minutes"](), s = date[_ + "Seconds"](), L = date[_ + "Milliseconds"](), o = utc ? 0 : date.getTimezoneOffset(), flags = {
            d: d,
            dd: DateUtils.pad(d),
            ddd: DateUtils.i18n.dayNames[D],
            dddd: DateUtils.i18n.dayNames[D + 7],
            M: M + 1,
            MM: DateUtils.pad(M + 1),
            MMM: DateUtils.i18n.monthNames[M],
            MMMM: DateUtils.i18n.monthNames[M + 12],
            yy: String(y).slice(2),
            yyyy: y,
            h: H % 12 || 12,
            hh: DateUtils.pad(H % 12 || 12),
            H: H,
            HH: DateUtils.pad(H),
            m: m,
            mm: DateUtils.pad(m),
            s: s,
            ss: DateUtils.pad(s),
            l: DateUtils.pad(L, 3),
            L: DateUtils.pad(L > 99 ? Math.round(L / 10) : L),
            t: H < 12 ? "a" : "p",
            tt: H < 12 ? "am" : "pm",
            T: H < 12 ? "A" : "P",
            TT: H < 12 ? "AM" : "PM",
            Z: utc ? "UTC" : (String(date).match(DateUtils.timezone) || [""]).pop().replace(DateUtils.timezoneClip, ""),
            o: (o > 0 ? "-" : "+") + DateUtils.pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
            S: ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
        };
        return formatString.replace(DateUtils.token, function ($0) {
            return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
        });
    };
    DateUtils.pad = function (val, len) {
        if (len === void 0) { len = 2; }
        val = String(val);
        while (val.length < len)
            val = "0" + val;
        return val;
    };
    ;
    /**
     * Tries to parse a date from a string using the supplied format string
     * @param dateString The string to parse
     * @param format The format string. This is only used to get the order of d/m/y
     * @param requireAllParts True if day month and year must be specified
     * @param refDate Reference date. E.g. if the year is ommitted in the date string, then the year from the reference date will be used. Today is used if no reference date is supplied.
    */
    DateUtils.tryParse = function (dateString, format, requireAllParts, refDate) {
        if (format === void 0) { format = ""; }
        if (requireAllParts === void 0) { requireAllParts = false; }
        if (!dateString)
            return null;
        if (!format)
            format = DateUtils.defaultFormatString;
        var returnDate = !refDate ? new Date() : new Date(refDate);
        // Find the position of d m and y in the format string.
        var d = format.indexOf('d'), m = format.indexOf('M'), y = format.indexOf('y'), Extra = 100;
        // Check for time component.
        var timeString = "";
        var isPM = false;
        var timePos = dateString.indexOf(":");
        if (timePos == -1) {
            timePos = dateString.toUpperCase().indexOf("PM");
        }
        if (timePos == -1) {
            timePos = dateString.toUpperCase().indexOf("AM");
        }
        if (timePos >= 1) {
            timePos = Math.max(0, timePos - (dateString[timePos - 1] == " " ? 3 : 2));
            timeString = dateString.substring(timePos);
            dateString = dateString.substring(0, timePos);
            isPM = timeString.toUpperCase().indexOf("PM") > 0;
            timeString = timeString.replace(/a/gi, "").replace(/p/gi, "").replace(/m/gi, "").replace(/ /gi, "");
        }
        // Date component
        if (d >= 0 || m >= 0 || y >= 0) {
            // Add missing d/m/y on the end.
            d = d == -1 ? Extra++ : d;
            m = m == -1 ? Extra++ : m;
            y = y == -1 ? Extra++ : y;
            // Replace common separators in the date string with /
            var str = dateString.replace(/-/g, '/').replace(/ /g, '/').replace(/\xA0/g, '/');
            // If the user doesnt put in separators, e.g. 0103, then add them to make the string value 01/03
            if ((d == 0 || m == 0) && str.indexOf('/') == -1 && str.length >= 4 && !isNaN(+str)) {
                str = str.substring(0, 2) + '/' + str.substring(2, 4) + (str.length == 8 || str.length == 6 ? '/' + str.substring(4, str.length) : '');
            }
            var parts = str.split('/');
            if (requireAllParts && parts.length < 3)
                return null;
            // if format is dd mmm yyyy, and the user omits the dd, then add 1st day.
            if (d == 0 && parts[0].length > 2)
                parts.splice(0, 0, "1");
            var Year = y > m ? (y > d ? parts[2] : parts[1]) : (y > d ? parts[1] : parts[0]);
            var Month = m > d ? (m > y ? parts[2] : parts[1]) : (m > y ? parts[1] : parts[0]);
            var Day = d > m ? (d > y ? parts[2] : parts[1]) : (d > y ? parts[1] : parts[0]);
            if (Year && (Year.length == 1 || Year.length == 3 || Year.length > 4))
                return null;
            Year = !Year ? returnDate.getFullYear().toString() : Year;
            Month = !Month ? (returnDate.getMonth() + 1).toString() : Month;
            Day = !Day ? 1 : Day;
            if (Month.length < 3 && parseInt(Month) <= 12) {
                Month = DateUtils.i18n.monthNames[parseInt(Month) - 1];
            }
            if (Year.length == 2) {
                if (requireAllParts) {
                    return null;
                }
                Year = "20" + Year;
            }
            returnDate = new Date(Day + " " + Month + " " + Year);
            if (isNaN(returnDate)) {
                return null;
            }
        }
        // Get time component.
        if (timeString) {
            var time = new Date(0);
            time.setHours.apply(time, timeString.split(":").map(function (s) { return parseInt(s); }));
            if (isNaN(time)) {
                return returnDate;
            }
            returnDate.setHours(time.getHours() + (isPM ? 12 : 0), time.getMinutes(), time.getSeconds());
        }
        return returnDate;
    };
    DateUtils.min = function (date1, date2) {
        return new Date(date1.getTime() < date2.getTime() ? date1 : date2);
    };
    DateUtils.max = function (date1, date2) {
        return new Date(date1.getTime() > date2.getTime() ? date1 : date2);
    };
    /** Returns the first date of the month for the specified date. */
    DateUtils.monthStart = function (date) {
        if (date === void 0) { date = new Date(); }
        return new Date(date.getFullYear(), date.getMonth(), 1);
    };
    /** Returns the last date of the month for the specified date. */
    DateUtils.monthEnd = function (date) {
        if (date === void 0) { date = new Date(); }
        return new Date(date.getFullYear(), date.getMonth() + 1, 0);
    };
    /**
     * Returns the current date without time.
     */
    DateUtils.today = function () {
        return this.stripTime(new Date());
    };
    /**
     * Returns a new date with no time component.
     */
    DateUtils.stripTime = function (dateWithTime) {
        return new Date(dateWithTime.getFullYear(), dateWithTime.getMonth(), dateWithTime.getDate());
    };
    /**
     * Returns a new date, with the timespan components added to it.
     * Use negative numbers to subtract.
     */
    DateUtils.add = function (date, timeSpan) {
        var _a, _b, _c, _d, _e, _f, _g;
        var newDate = new Date();
        newDate.setFullYear(date.getFullYear() + ((_a = timeSpan.years) !== null && _a !== void 0 ? _a : 0), date.getMonth() + ((_b = timeSpan.months) !== null && _b !== void 0 ? _b : 0), date.getDate() + ((_c = timeSpan.days) !== null && _c !== void 0 ? _c : 0));
        newDate.setHours(date.getHours() + ((_d = timeSpan.hours) !== null && _d !== void 0 ? _d : 0), date.getMinutes() + ((_e = timeSpan.minutes) !== null && _e !== void 0 ? _e : 0), date.getSeconds() + ((_f = timeSpan.seconds) !== null && _f !== void 0 ? _f : 0), date.getMilliseconds() + ((_g = timeSpan.milliseconds) !== null && _g !== void 0 ? _g : 0));
        if (timeSpan.months && !timeSpan.days) {
            // 31 May - 1 month == 31 April == 1 May, this will fix that:
            var newMonth = newDate.getMonth();
            var oldMonth = date.getMonth();
            // JS % operator gives remainder, not mod
            if (newMonth !== ((oldMonth + (timeSpan.months % 12) + 12) % 12)) {
                newDate.setDate(0);
            }
        }
        return newDate;
    };
    /**
     * Gets the difference between 2 dates.
     */
    DateUtils.difference = function (startDate, endDate) {
        var compareDate = new Date();
        compareDate.setFullYear(endDate.getFullYear() - startDate.getFullYear(), endDate.getMonth() - startDate.getMonth(), endDate.getDate() - startDate.getDate());
        compareDate.setHours(endDate.getHours() - startDate.getHours(), endDate.getMinutes() - startDate.getMinutes(), endDate.getSeconds() - startDate.getSeconds(), endDate.getMilliseconds() - startDate.getMilliseconds());
        return new TimeSpan(compareDate.getFullYear(), compareDate.getMonth(), compareDate.getDate(), compareDate.getHours(), compareDate.getMinutes(), compareDate.getSeconds(), compareDate.getMilliseconds(), endDate.getTime() - startDate.getTime());
    };
    DateUtils.defaultFormatString = "dd MMM yyyy";
    DateUtils.defaultFormatStringWithTime = "dd MMM yyyy HH:mm";
    DateUtils.token = /d{1,4}|M{1,4}|yy(?:yy)?|([HhmsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g;
    DateUtils.timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g;
    DateUtils.timezoneClip = /[^-+\dA-Z]/g;
    /*
    * Date Format 1.2.3
    * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
    * MIT license
    *
    * Includes enhancements by Scott Trenda <scott.trenda.net>
    * and Kris Kowal <cixar.com/~kris.kowal/>
    */
    DateUtils.i18n = {
        dayNames: [
            "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat",
            "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
        ],
        monthNames: [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
            "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
        ]
    };
    return DateUtils;
}());
export default DateUtils;
